<template>
  <div class="container card card-body card-full-width-mobile mt-3 mt-md-9 p-0 p-lg-4 text-center">
    <h2 class="text-primary mt-6">Ja, ik kies voor zonnepanelen!</h2>
    <p>Vul uw persoonlijke code in en kijk wat u gaat besparen</p>
    <B2bLoginForm></B2bLoginForm>
    <div class="mt-8">
      <h2 class="text-primary">Contactgegevens</h2>
      <p class="mt-4">Lees hier de <a :href="`https://www.sungevity.nl/huurdak/faq-${$route.params.company}/`"  target="_blank">veelgestelde vragen</a></p>
      <b-row class="justify-content-center">
        <b-col cols="12" md="8">
          <p>Staat uw vraag er niet tussen? Neem dan gerust contact met ons op. We zijn op werkdagen tussen
            09:00 en 17:00 bereikbaar op 020 309 09 01 of via huurdak@sungevity.nl</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import B2bLoginForm from '@/components/b2b/B2bLoginForm'
export default {
  name: 'B2bLogin',
  components: {
    B2bLoginForm
  }
}
</script>
